import * as React from "react"
import { cn } from "@/utils"

const Switch = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement> & { onCheckedChange?: (checked: boolean) => void }
>(({ className, checked, onCheckedChange, ...props }, ref) => (
  <label className="relative inline-flex items-center cursor-pointer">
    <input
      ref={ref}
      type="checkbox"
      checked={checked}
      className="sr-only peer"
      onChange={(e) => {
        onCheckedChange?.(e.target.checked);
        props.onChange?.(e);
      }}
      {...props}
    />
    <div
      className={cn(
        "relative inline-flex h-6 w-11 shrink-0 items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 bg-input peer-checked:bg-primary",
        className
      )}
    >
      <div
        className={cn(
          "pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform translate-x-0 peer-checked:translate-x-5"
        )}
      />
    </div>
  </label>
))
Switch.displayName = "Switch"

export { Switch }